import React from 'react';
export var FormContext = React.createContext({
  editStatus: false
});
export var TableContext = React.createContext({
  toggle: function toggle() {
    return null;
  }
});